import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=039a5714&"
import script from "./TagSelect.vue?vue&type=script&lang=js&"
export * from "./TagSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039a5714')) {
      api.createRecord('039a5714', component.options)
    } else {
      api.reload('039a5714', component.options)
    }
    module.hot.accept("./TagSelect.vue?vue&type=template&id=039a5714&", function () {
      api.rerender('039a5714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/TagSelect.vue"
export default component.exports